import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import i18next from "i18next";

import {
    GET,
    newFetch
} from '../../helpers/fetch'
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from "../../config/index";
const { API_URL } = config;

const ChooseLanguage = ({ history }) => {
    const user = JSON.parse(localStorage.getItem('user'))
  const associate_id = JSON.parse(localStorage.getItem("user")).id;
  const myLanguage = JSON.parse(localStorage.getItem("user")).language;
  const [associate, setAssociate] = useState(null)
  const token = localStorage.getItem("token");

  const [language, setLanguage] = useState("");

  const languageHandler = (e) => setLanguage(e.target.value);

  const submitHandler = async (e) => {
    e.preventDefault();
    let url = `${API_URL}/associate/${associate_id}/select-language`;

    try {
      let data = {
        language,
      };

      let response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        withCredentials: true,
        mode: "cors",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
        },
      });

      let json = await response.json();

      if (response.ok) {
        ToastUtil.success("Language successfully updated.");
      } else {
        ToastUtil.error(json.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const periodType = [
    { label: "English", value: "en" },
    { label: "Mandarin (普通)", value: "chi" },
  ];

  const handlePeriodTypeSelection = (value) => {
    i18next.changeLanguage(value)
    setLanguage(value);
  };

  const fetchUser = async () => {
    let api_path = "/associate/aboutme";
    let response = await newFetch(GET, api_path);

    response.success && setAssociate(response.data);
  };

  useEffect(() => {
    if (user) {
      fetchUser();
    }
  }, []);

  useEffect(() => {
    associate && associate?.language && setLanguage(associate.language);
  }, [associate]);

  return (
    <div className="container">
      <form className="form" onSubmit={(e) => submitHandler(e)}>
        <div
          className="d-flex flex-column justify-content-between"
          style={{ minHeight: "calc(100vh - 57px)" }}
        >
          <div className="flex-grow-1 d-flex flex-column mt-4">
            {periodType.map((type, index) => (
              <div className="form-check me-3 mb-1 language-radio" key={index}>
                <input
                  className="form-check-input ml-2 language-radio-input"
                  type="radio"
                  name="itemType"
                  id={`itemType-${index}`}
                  value={type.value}
                  checked={type.value === language}
                  onChange={({ target: { value } }) =>
                    handlePeriodTypeSelection(value)
                  }
                />
                <label
                  className="form-check-label label-radio"
                  htmlFor={`itemType-${index}`}
                >
                  {type.label}
                </label>
              </div>
            ))}
          </div>

          <button
            type="submit"
            className="btn btn-design btn-brand btn-block mb-4"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default withRouter(ChooseLanguage);
